import styled from 'styled-components';

export const Container = styled.header`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0 4rem 1.6rem;

  background-color: #41474e;
  height: 14rem;
  width: 100%;

  @media (max-width: 600px) {
    padding: 0 0.8rem 1.6rem;
    height: 8rem;

    > nav {
      display: none;
    }
  }
`;

export const LogoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  img {
    align-self: flex-start;
    width: 6.4rem;
    height: 6.4rem;
  }

  span {
    font-size: 1.4rem;
    color: #fff;
    font-weight: bold;
    margin-top: 0.8rem;
  }

  @media (max-width: 600px) {
    display: none;
  }
`;

export const Navigation = styled.nav`
  display: flex;
  align-items: center;

  a {
    position: relative;
    font-size: 1.4rem;
    color: #fff;
    padding: 0 0.8rem;
    transition: filter 200ms;

    &:hover {
      filter: brightness(50%);
    }

    &.active {
      font-weight: bold;

      &::after {
        position: absolute;
        content: '';
        bottom: -10px;
        left: 50%;
        width: 5px;
        height: 5px;
        border-radius: 50%;
        background-color: #fff;
      }
    }
  }

  button {
    color: #fff;
    border: none;
    background: transparent;
    font-size: 1.4rem;
    transition: filter 200ms;

    &:hover {
      filter: brightness(50%);
    }

    @media (max-width: 600px) {
      color: #ff0033;
      font-weight: 700;
      margin-top: 0.8rem;
      width: 100%;
    }
  }

  @media (max-width: 600px) {
    flex-direction: column;
    width: 100%;
  }
`;

export const Separator = styled.div`
  display: inline-block;
  margin: 0 1.6rem 0 0.8rem;
  height: 1.6rem;
  width: 2px;
  background-color: #fff;

  @media (max-width: 600px) {
    margin: 0;
    background-color: #cdcdcd;
    height: 2px;
    width: 100%;
  }
`;

export const MenuMobileButton = styled.button`
  display: none;
  border: none;
  background: transparent;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.7;
  }

  @media (max-width: 600px) {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex: 1;

    div {
      display: flex;
      align-items: center;

      span {
        margin-left: 0.8rem;
      }
    }

    span {
      color: #fff;
      font-weight: 700;
    }
  }
`;

export const MenuMobile = styled.div<{ isOpen: boolean }>`
  --menu-width: 60%;
  position: fixed;
  top: 0;
  left: calc(var(--menu-width) * -1);
  bottom: 0;
  z-index: 100;
  width: var(--menu-width);
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  transition: transform 0.2s;
  transform: ${({ isOpen }) => isOpen && 'translateX(100%)'};

  a {
    padding: 1.6rem;
    width: 100%;
    color: #222;

    transition: all 0.2s;

    &.active {
      background: #41474e;
      color: #fff;

      &::after {
        display: none;
      }
    }

    &:not(.active):hover {
      filter: none;
      background: #cecece;
      color: #fff !important;
    }

    &:not(.active):visited {
      color: #222;
    }
  }

  header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1.6rem;
    width: 100%;
    border-bottom: 1px solid #cecece;

    span {
      font-weight: 700;
    }

    button {
      border: none;
      background: transparent;
      font-size: 2.4rem;
      transition: background 200ms;
      color: #c1c1c1;

      &:hover {
        background: #f5f5f5;
      }
    }
  }

  @media (min-width: 601px) {
    display: none;
  }
`;

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  background: #000;
  opacity: 0.5;
  z-index: 99;
  width: 100%;

  @media (min-width: 601px) {
    display: none;
  }
`;
